import React, {useEffect, useImperativeHandle, useRef} from "react";
import {OrderedListOutlined} from "@ant-design/icons";
import {Col, Form, Input, Modal, Row,InputNumber} from "antd";
import {useModel} from "../../../models";

const AdjustForm = ({formRef}) => {
    const [{selectedAccount,selectedSupplier}, {adjustAccount, setAdjustModelVisible}] = useModel("supplier");
    const [form] = Form.useForm();
    const [{ accountTyprDict }, { getAccountTyprDict }] = useModel("cmDict");

    useEffect(() => {
        // console.log(selectedSupplier,selectedAccount)
        // let aaa = ""
        // accountTyprDict.forEach(item=>{
        //     if(item.key==selectedSupplier.accountType){
        //         console.log(item)
        //         return aaa = item.label
        //     }
        // })
        // console.log(aaa)
        form.setFieldsValue({...selectedAccount,...selectedSupplier});
        form.setFieldsValue({accountType:"授信账户"});

    }, [selectedAccount]);

    useImperativeHandle(formRef, () => ({
        form: () => {
            return form;
        },
        adjust: () => {
            // console.log(form.getFieldsValue());
            form.validateFields().then(datas => {
                // selectedAccount
                console.log(datas)
                let data = {                    
                    ...datas,
                    id:selectedAccount.id,
                    accountType:selectedAccount.accountType
                }
                adjustAccount({data}).then(() => {
                    setAdjustModelVisible(false);
                });

            })
        },
        reset: () => {
            form.resetFields();
        },
    }));
    return (
        <Form
            form={form}
            name="material_detail"
            labelCol={{span: 6}}
            style={{marginRight: "50px"}}
        >
            {/*<Row>
                <Col span={12}>
                    <Form.Item
                        name="供应商"
                        label="供应商"
                    >
                        <Input disabled={true} placeholder="商品编号供应商"/>
                    </Form.Item>
                </Col>

                <Col span={12}>
                    <Form.Item
                        name="账户类型"
                        label="账户类型"
                    >
                        <Input disabled={true} placeholder="账户类型"/>
                    </Form.Item>
                </Col>
            </Row>*/}
                    <Form.Item
                        name="supplierName"
                        label="供应商名称"
                    >
                        <Input disabled={true} placeholder="供应商名称"/>
                    </Form.Item>
                    <Form.Item
                        name="accountType"
                        label="账户类型"
                    >
                        <Input disabled={true} placeholder="账户类型"/>
                    </Form.Item>                    
                    <Form.Item
                        name="creditLine"
                        label="授信额度"
                    >
                        <Input disabled={true} placeholder="授信额度"/>
                    </Form.Item>                    
                    <Form.Item
                        name="adjustmentlimit"
                        label="调整额度"
                        rules={[{required: true, message: '调整额度是必输项',}]}
                    >
                        <InputNumber placeholder="调整额度"/>
                    </Form.Item>
                    <Form.Item
                        name="remarks"
                        label="备注"
                        // labelCol={{span: 3}}
                    >
                        <Input placeholder="备注"/>
                    </Form.Item>
        </Form>
    )
}

export default function () {
    const [{adjustModelVisible, selectedAccount}, {setAdjustModelVisible}] = useModel("supplier")

    const formRef = useRef();

    const onOk = () => {
        formRef.current.adjust();

    }
    const onClose = () => {
        setAdjustModelVisible(false);
    }
    const Title = () => {
        return (
            <h3 style={{flex: "1"}}>
                <OrderedListOutlined/>
                <span className="margin-left-8">授权额度调整</span>
                <span className="margin-left-16">{selectedAccount.supplierName}-{selectedAccount.ccountTypeName}</span>
            </h3>
        )
    }
    return (
        <Modal
            title={<Title/>}
            width={500}
            visible={adjustModelVisible}
            onOk={onOk}
            onCancel={onClose}
        >
            <AdjustForm formRef={formRef}/>
        </Modal>
    );
}